export const formatCurrency = (value: number, decimalCount = 2): string =>
  (value / 100).toFixed(decimalCount).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
